"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityShiftListCountsDto = instanceOfFacilityShiftListCountsDto;
exports.FacilityShiftListCountsDtoFromJSON = FacilityShiftListCountsDtoFromJSON;
exports.FacilityShiftListCountsDtoFromJSONTyped = FacilityShiftListCountsDtoFromJSONTyped;
exports.FacilityShiftListCountsDtoToJSON = FacilityShiftListCountsDtoToJSON;
exports.FacilityShiftListCountsDtoToJSONTyped = FacilityShiftListCountsDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityShiftListCountsDto interface.
 */
function instanceOfFacilityShiftListCountsDto(value) {
    if (!('open' in value) || value['open'] === undefined)
        return false;
    if (!('upcoming' in value) || value['upcoming'] === undefined)
        return false;
    if (!('canceled' in value) || value['canceled'] === undefined)
        return false;
    if (!('complete' in value) || value['complete'] === undefined)
        return false;
    if (!('all' in value) || value['all'] === undefined)
        return false;
    return true;
}
function FacilityShiftListCountsDtoFromJSON(json) {
    return FacilityShiftListCountsDtoFromJSONTyped(json, false);
}
function FacilityShiftListCountsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'open': json['open'],
        'upcoming': json['upcoming'],
        'canceled': json['canceled'],
        'complete': json['complete'],
        'all': json['all'],
    };
}
function FacilityShiftListCountsDtoToJSON(json) {
    return FacilityShiftListCountsDtoToJSONTyped(json, false);
}
function FacilityShiftListCountsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'open': value['open'],
        'upcoming': value['upcoming'],
        'canceled': value['canceled'],
        'complete': value['complete'],
        'all': value['all'],
    };
}
//# sourceMappingURL=FacilityShiftListCountsDto.js.map